module.exports = __webpack_public_path__ + "media/images/home/hero_widget_bg-b600b9354581b655d8b8d007f6c5541f.jpg";